import React from "react";
import { SERVER_URL } from "../../api/url";

const TestCard = ({ currentLevelAnswers, setCurrentLevelAnswers, item }) => {
  if (!item) return null;

  // multimedia file logic
  const fileUrl = item.file ? `https://back.yourfrenchteachers.com/${item.file}` : null;

  // Radio button နှိပ်လိုက်တဲ့အခါ သက်ဆိုင်ရာ Question ID နဲ့ အဖြေကို တွဲသိမ်းပေးခြင်း
  const onOptionChange = (questionId, value) => {
    setCurrentLevelAnswers((prev) => ({
      ...prev,
      [questionId]: value,
    }));
  };

  return (
    <div className="test-card-container">
      {/* ၁။ Paragraph Section */}
      {item.paragraph && (
        <div className="mb-4 p-4 bg-light rounded shadow-sm" style={{ whiteSpace: "pre-line" }}>
          <p>{item.paragraph}</p>
        </div>
      )}

      {/* ၂။ Audio/Video Section */}
      {item.file && (
        <div className="mb-4 text-center">
          {item.file.toLowerCase().endsWith(".mp4") ? (
            <video key={item.file} controls className="w-100 rounded">
              <source src={fileUrl} type="video/mp4" />
            </video>
          ) : (
            <audio key={item.file} controls className="w-100">
              <source src={fileUrl} type="audio/mpeg" />
            </audio>
          )}
        </div>
      )}

      {item.questions?.map((q, qIndex) => (
        <div key={q._id} className="card px-4 py-4 mb-3">
          <h5 className="mb-3 text-primary">
            Question {qIndex + 1}: {q.questionText}
          </h5>
          
          <div className="options-list mt-3">
            {q.options?.map((option, index) => (
              <div key={index} className="form-check py-2">
                <input
                  className="form-check-input"
                  type="radio"
                  // မေးခွန်းတစ်ခုချင်းစီအတွက် group ခွဲရန် name ကို question ID သုံးသည်
                  name={`question-group-${q._id}`} 
                  id={`opt-${q._id}-${index}`}
                  value={option}
                  onChange={() => onOptionChange(q._id, option)}
                  // လက်ရှိ မေးခွန်းရဲ့ အဖြေရွေးထားသလား စစ်သည်
                  checked={currentLevelAnswers[q._id] === option}
                />
                <label className="form-check-label ml-2 pointer" htmlFor={`opt-${q._id}-${index}`}>
                  {option}
                </label>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TestCard;